// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import Footer from "../../widgets/Footer";
import DataTable from "../../widgets/Tables/DataTable";
import ToastWidget from "widgets/Toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { styles } from './styles';
import { ComboBox } from './../commons/Combobox';
import {
  getServersByNetwork,
  deleteServer,
  getServer,
} from "../../domain/apis/serverService";
import { getNetworks } from '../../domain/apis/networkService';
import ServerModifyComponent from "./serverModifyComponent";

// Data
import renderTableData from "./data/tableData";

function Servers() {
  const [dataset, setDataset] = useState({
    columns: [],
    rows: [],
  });

  const [uiToast, setUIToast] = useState({
    isShow: false,
    message: "",
  });

  const [networks, setNetworks] = useState([]);
  const [networkID, setNetworkID] = useState();

  const [reload, setReload] = useState(0);
  const [modifyDialogShow, setModifyDialogShow] = useState({
    show: false,
    data: null,
  });

  const reloadPage = () => {
    setReload(reload + 1);
  };

  function fetchNetworks() {
    getNetworks().subscribe({
      next({ data }) {
        const { value } = data;
        setNetworks(value);
      },
      error(err) {
        console.log(err);
      },
    });
  }

  useEffect(() => {
    fetchNetworks();
  }, []);

  useEffect(() => {
    // reset
    setDataset({
      columns: [],
      rows: [],
    });

    getServersByNetwork(networkID).subscribe({
      next({ data }) {
        const { value } = data;
        setDataset(
          renderTableData({
            model: value,
            deleteEvent,
            editEvent,
          })
        );
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }, [reload, networkID]);

  function handleDelete(id) {
    deleteServer(id).subscribe({
      next({ data }) {
        if (data.status) {
          setUIToast({
            isShow: true,
            message: "Đã xoá!!!",
          });

          setTimeout(() => {
            reloadPage();
          }, 2000);
        }
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }

  function handleShowEdit(id) {
    getServer(id).subscribe({
      next({ data }) {
        setModifyDialogShow({
          show: true,
          data: data,
        });
      },
      error(err) {
        setUIToast({
          isShow: true,
          message: err.message,
        });
      },
    });
  }

  // events
  function deleteEvent(id) {
    const choice = window.confirm("Bạn có muốn xoá?");
    if (choice) {
      handleDelete(id);
    }
  }

  function editEvent(id) {
    handleShowEdit(id);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastWidget
        key="toast"
        isShow={uiToast.isShow}
        message={uiToast.message}
        onClose={() => setUIToast({ isShow: false })}
      />
      <ServerModifyComponent
        data={modifyDialogShow.data}
        show={modifyDialogShow.show}
        networks={networks}
        handleClose={(forceReload) => {
          setModifyDialogShow({
            show: false,
          });
          if (forceReload) {
            reloadPage();
          }
        }}
      />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <div style={{ textAlign: "end", paddingRight: 24 }}>
                  <Button
                    onClick={() => {
                      setModifyDialogShow({
                        show: true,
                        data: undefined,
                      });
                    }}
                    variant="contained"
                    style={{
                      color: "white",
                    }}
                  >
                    Tạo mới
                  </Button>
                </div>
                <Row style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 24 }}>
                  <Col className="col-6 col-md-4" style={{ ...styles.selfCenter, ...styles.textNormal }}>Network</Col>
                  <Col className="col-12 col-sm-6 col-md-8">
                    <ComboBox
                      value={networkID}
                      placeHolder={"--- Tất cả ---"}
                      data={networks}
                      onItemChange={(value) => {
                        setNetworkID(value);
                      }} />
                  </Col>
                </Row>
                <DataTable
                  table={dataset}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Servers;
